import React from "react";
import styles from "./common.module.css";

function button({ name, type, className, ...props }) {
  return (
    <button type={type} className={`${className}  ${styles.btn}`} {...props}>
      <p>{name}</p>
    </button>
  );
}

export default button;
